<div @routeAnimation role="navigation">
    <router-outlet />
</div>
